import { fetcher } from "helpers/fetcher";

import { TGetOrganizationListReq, TGetOrganizationListRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getOrganizationList = async (params?: TGetOrganizationListReq) => {
  return await fetcher<
    TGetOrganizationListRes,
    TGetOrganizationListReq["data"]
  >(ENDPOINT.CORPORATION.GET_ORGANIZATION_LIST, {
    params: params?.data,
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.CORPORATION.GET_ORGANIZATION_LIST.version,
      [API_HEADER.CORP_ID]: params?.idCorp,
    },
  });
};

export const queryGetOrganizationList = async (
  params?: TGetOrganizationListReq
) => {
  return (await getOrganizationList(params)).data;
};

queryGetOrganizationList._key = (
  params?: TGetOrganizationListReq,
  key?: number
) => [ENDPOINT.CORPORATION.GET_ORGANIZATION_LIST.url, params, key];
